<template>
    <div>
        <fieldset>
            <div style="padding: 20px;">
                <div class="row">
                  <div class="col-md-4">
                        <label for="currency_name">Currency Name</label>
                        <input type="text" id="currency_name" placeholder="Currency Name"  v-model="$parent.exchange_rate_from_fields.name">
                    </div>
                    <div class="col-md-4">
                      <label for="currency_short_name">Currency Short Name</label>
                      <input type="text" id="currency_short_name" placeholder="Currency Short Name"  v-model="$parent.exchange_rate_from_fields.short_name">
                    </div>
                    <div class="col-md-4">
                      <label for="currency_symbol">Currency Symbol</label>
                      <input type="text" id="currency_symbol" placeholder="Currency Symbol"  v-model="$parent.exchange_rate_from_fields.symbol">
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-md-4">
                      <label for="exchange_rate">Exchange Rate</label>
                      <input id="exchange_rate" type="number" step="0.01" class="m-0" placeholder="Exchange Rate" v-model="$parent.exchange_rate_from_fields.exchange_rate">
                    </div>
                    <div class="col-md-4">
                      <label for="start-date"> Start Date</label>
                      <input id="start-date" type="date" class="m-0" v-model="$parent.exchange_rate_from_fields.start_date">
                    </div>
                    
                    <div class="col-md-3">
                      <label for="end-date"> End Date</label>
                      <input id="end-date" type="date" class="m-0" v-model="$parent.exchange_rate_from_fields.end_date">
                    </div>
                    
                </div>
            </div>
        </fieldset>
    </div>
  </template>
  
<script>
export default {
  name: 'CurrencyExchangeRateFields',
  data () {
    return {
      
    }
  }
}
</script>


  